<select
    #select
    [class.is-placeholder]="!selectedValue"
    [attr.aria-label]="placeholder"
    [disabled]="disabled"
    (change)="changeSelection(select.value)"
>
    @if (hasPlaceholder()) {
        <option value="" disabled selected>{{ placeholder }}</option>
    }
    @for (option of options; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
    }
</select>
<mat-icon class="dropdown-icon" svgIcon="arrow-down"></mat-icon>
